// src/redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./features/authSlice";
import quickQuoteReducer from "./features/quickQuateSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    quickQuote: quickQuoteReducer,
  },
});
